module.exports = "/_next/static/images/website-webapp-banner-icon-567a3fad8926ed39ea4c75722a41ea95.webp";